export default __webpack_public_path__ + "static/notice-underline-0e718bb8a5173b0ce1cf88b72df6f879.svg";